import CommonAPIService from './CommonHandler';
import axios from 'axios';

export class FileobjectsAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  uploadFile(files, router) {
    const url = '/api/file_objects';
    return this.CommonAPIService.fileCall(url, files, router)
  }

  uploadFileToFirm(files, fid, router) {
    const url = '/api/file_objects';
    files.set('fid', fid);
    return this.CommonAPIService.fileCall(url, files, router)
  }

  updateFileObject(id, file_object, router) {
    const url = `/api/file_objects/${id}`;
    return this.CommonAPIService.putCall(url, file_object, router);
  }

  listFileObject(id, router) {
    const url = `/api/file_objects/${id}`;
    return this.CommonAPIService.getCall(url, router);
  }

  createFileObject(file_object, router) {
    const url = '/api/file_objects';
    return this.CommonAPIService.postCall(url, file_object, router);
  }

  deleteFileObject(id, router) {
    const url = `/api/file_objects/${id}`;
    return this.CommonAPIService.deleteCall(url, router);
  }

  /**
   * Fetches all form files.
   * @param {number} fid - The firm ID used to return a loidfid id.
   * @param {object} router - Router instance used for navigation or request context.
   * @returns {Promise<any>} A promise that resolves with the API response containing form file objects.
   */
  getAllForms(fid, router) {
    const params = new URLSearchParams({
      fid,
      fields: 'loid,filename,f_type,file_description,size,loidfid',
      orders: 'f_type,file_description'
    }).toString();

    const url = `/api/file_objects/forms?${params}`;
    return this.CommonAPIService.getCall(url, router);
  }
}

export default FileobjectsAPIService;
